import api from '../../helpers/axios'

export const state = {
    site: null,
    sites: []
};

export const getters = {
    site: (state) => state.site,
    sites: (state) => state.sites,
};

export const mutations = {
    setSite(state, newValue) {
        state.site = newValue;
    },
    setSites(state, newValue) {
        state.sites = newValue;
    },
};

export const actions = {
    createSite(_, data) {
        return new Promise((resolve, reject) => {
            api.post("/sites", data).then((res) => {
                if (res) {
                    resolve(res.data.data)
                }
            }).catch((err) => {
                reject(err)
            })
        });
    },
    updateSite(_, {id, data}) {
        return new Promise((resolve, reject) => {
            api.put("/sites/" + id, data).then((res) => {
                resolve(res.data.data);
            }).catch((err) => {
                reject(err);
            });
        });
    },


    deleteSite(_, id) {
        return new Promise((resolve) => {
            api.delete("/sites/" + id).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    fetchSite({commit}, {id}) {
        return new Promise((resolve, reject) => {
            api.get("/sites/" + id).then((res) => {
                commit("setSite", res.data.data);
                resolve(res.data.data)
            }).catch(err => {
                reject(err)
            })
        });
    },

    fetchSites({commit}, {domain, field, isActive, page, limit, listType, search}) {
        let query = "?";

        if (listType) {
            query += `listType=${listType}&`;
        } else {
            query += `page=${page}&`;
            query += `limit=${limit}&`;
        }
        if (domain) {
            query += `domain=${domain}&`;
        }
        if (field) {
            query += `field=${field}&`;
        }
        if (search) {
            query += `q=${search}&`;
        }

        if (isActive !== undefined) {
            query += `isActive=${isActive}&`;
        }

        return new Promise((resolve) => {
            api.get("/sites" + query).then((res) => {
                commit("setSites", res.data.data);
                resolve(res.data.data);
            });
        });
    },
};
